import axios from 'axios'

const headers = {
  Accept: 'application/json, text/javascript',
  'Authorization': localStorage.getItem('jwt')
}

export const httpService = axios.create({ headers })

export const apiService = () => {
  const splittedURL = window.location.href.split('/v4')
  if (splittedURL.length === 0) {
    return httpService
  }

  return axios.create({
    headers,
    baseURL: splittedURL[0]
  })
}

export default httpService
